<alaris-dialog
	[loading$]="exporting$"
	[closeAction]="close.bind(this)"
	[confirmButtonText]="''"
	size="auto"
	[closeButtonText]="''">
	<alaris-copy data="DD-{{ mdTask.mdTaskID }}" slot="header" class="copy"></alaris-copy>
	<h4 slot="header">{{ 'manual_dipping.task.title' | translate }}&nbsp;DD-{{ mdTask.mdTaskID }}</h4>
	<div slot="content">
		<div class="task-statistics">
			<div>
				<h6>{{ mdTask.totalAmount }}</h6>
				<div>{{ 'manual_dipping.task.total' | translate }}</div>
			</div>
			<div>
				<h6>{{ mdTask.successfulAmount }}</h6>
				<div>{{ 'manual_dipping.task.successful' | translate }}</div>
			</div>
			<div>
				<h6>{{ mdTask.portedAmount }}</h6>
				<div>{{ 'manual_dipping.task.ported' | translate }}</div>
			</div>
			<div>
				<h6>{{ mdTask.notPortedAmount }}</h6>
				<div>{{ 'manual_dipping.task.not_ported' | translate }}</div>
			</div>
			<div>
				<h6>{{ mdTask.cachedAmount }}</h6>
				<div>{{ 'manual_dipping.task.cached' | translate }}</div>
			</div>
			<div>
				<h6 class="task-errors">{{ mdTask.errorsAmount }}</h6>
				<div>{{ 'manual_dipping.task.errors' | translate }}</div>
			</div>
		</div>
		<div class="task-go">
			<button (click)="goToResults()" [ripple]="true"
					[disabled]="!this.user.allowed(['mdresult.read'])" alaris-button>
				{{ 'manual_dipping.task.go_to_results' | translate }}
				<alaris-icon name="icon-caret-right"></alaris-icon>
			</button>
		</div>
		<hr class="divider" />
		<div class="task-info">
			<div>
				<div>
					<alaris-icon name="icon-spinner"></alaris-icon>
					<div>{{ 'manual_dipping.status' | translate }}</div>
				</div>
				<div>
					<app-manual-dipping-status [mdTask]="mdTask"></app-manual-dipping-status>
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-rate"></alaris-icon>
					<div>{{ 'manual_dipping.source' | translate }}</div>
				</div>
				<div>
					{{ mdTask.sources.join(', ') }}
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-data"></alaris-icon>
					<div>{{ 'gl.created' | translate }}</div>
				</div>
				<div>
					{{ mdTask.createdAt | dateFormat }}
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-user-circle"></alaris-icon>
					<div>{{ 'gl.author' | translate }}</div>
				</div>
				<div>
					@if (mdTask.author?.details?.firstName && mdTask.author?.details?.lastName) {
					{{ mdTask.author?.details?.firstName }}&nbsp;{{ mdTask.author?.details?.lastName }}
					} @else {
					{{ mdTask.author?.login }}
					}
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-cloud-upload"></alaris-icon>
					<div>{{ 'manual_dipping.cache' | translate }}</div>
				</div>
				<div>
					@if (mdTask.noCache) {
					{{ 'manual_dipping.ignored' | translate }}
					} @else {
					{{ 'manual_dipping.included' | translate }}
					}
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-file"></alaris-icon>
					<div>{{ 'gl.file_word' | translate }}</div>
				</div>
				<div>
					<alaris-link [underline]="false" (click)="exportNumbers()">
						<span>numbers.xlsx</span>
						<alaris-icon
							name="icon-arrow-line-down"
							style="display: inline-block; margin-left: 0.35rem"></alaris-icon>
					</alaris-link>
				</div>
			</div>
		</div>
	</div>
	<div slot="footer-extra" class="footer-actions">
		<button alarisButton [bType]="'secondary'" size="lg" [ripple]="true" (click)="restart()">
			{{ 'manual_dipping.task.restart' | translate }}
		</button>
		<button alarisButton [bType]="'primary'" size="lg" [ripple]="true" (click)="confirm()"
				[disabled]="!this.user.allowed(['mdresult.read'])">
			{{ 'gl.export_results' | translate }}
			<alaris-icon name="icon-arrow-line-down"></alaris-icon>
		</button>
	</div>
</alaris-dialog>
